<template>
  <CardPrime v-if="variant === 'full'" class="django-gate mb-4">
    <template #title>
      <span class="flex align-items-center gap-2">
        <i class="pi pi-lock" />
        Acceso Estudyoo (actividades y juegos)
      </span>
    </template>
    <template #content>
      <p class="text-sm text-600 mb-3">
        Usa el mismo correo que en Google y la contraseña de tu usuario <strong>staff</strong>.
      </p>
      <div v-if="conectado" class="flex align-items-center gap-2 mb-2">
        <TagPrime severity="success" value="Conectado" />
        <ButtonPrime label="Cerrar sesión" class="p-button-sm p-button-outlined" @click="desconectar" />
      </div>
      <div v-else class="grid grid-cols-1 md:grid-cols-3 gap-3">
        <div>
          <label class="block text-sm mb-1">Email</label>
          <InputText v-model="email" class="w-full" placeholder="tu@correo.com" />
        </div>
        <div>
          <label class="block text-sm mb-1">Contraseña</label>
          <Password v-model="password" class="w-full" :feedback="false" toggle-mask input-class="w-full" />
        </div>
        <div class="flex align-items-end">
          <ButtonPrime label="Conectar" icon="pi pi-sign-in" :loading="cargando" @click="conectar" />
        </div>
      </div>
      <p v-if="error" class="text-sm text-red-500 mt-2">{{ error }}</p>
      <p class="text-xs text-500 mt-2">API: {{ backUrl || '—' }}</p>
    </template>
  </CardPrime>

  <div
    v-else
    class="django-gate-compact mb-3 flex flex-wrap align-items-center gap-2 surface-card border-1 surface-border border-round px-3 py-2"
  >
    <template v-if="conectado">
      <TagPrime severity="success" value="Conectado" />
      <span v-if="emailMostrar" class="text-xs text-500">{{ emailMostrar }}</span>
      <ButtonPrime label="Cerrar sesión" class="p-button-sm p-button-text ml-auto" @click="desconectar" />
    </template>
    <template v-else>
      <TagPrime severity="warn" value="Sin conexión" />
      <span class="text-sm text-600">Inicia sesión en el hub para continuar.</span>
      <ButtonPrime
        label="Ir al hub"
        icon="pi pi-arrow-right"
        icon-pos="right"
        class="p-button-sm p-button-outlined ml-auto"
        @click="irAlHub"
      />
    </template>
  </div>
</template>

<script setup>
import { ref, computed, onMounted } from 'vue';
import { useRouter } from 'vue-router';
import CardPrime from 'primevue/card';
import InputText from 'primevue/inputtext';
import Password from 'primevue/password';
import ButtonPrime from 'primevue/button';
import TagPrime from 'primevue/tag';
import {
  isDjangoAdminAuthenticated,
  loginDjangoAdmin,
  clearDjangoAdminSession,
} from '@/services/djangoAdminAuth';

const props = defineProps({
  variant: {
    type: String,
    default: 'compact',
    validator: (v) => ['full', 'compact'].includes(v),
  },
  hubRoute: {
    type: String,
    default: 'estudyoo-hub',
  },
});

const emit = defineEmits(['authenticated']);

const router = useRouter();
const backUrl = process.env.VUE_APP_BACK_URL || '(proxy local)';
const email = ref(sessionStorage.getItem('estudyoo_admin_django_email') || '');
const password = ref('');
const cargando = ref(false);
const error = ref('');
const conectado = ref(isDjangoAdminAuthenticated());

const emailMostrar = computed(() => email.value || sessionStorage.getItem('estudyoo_admin_django_email') || '');

onMounted(() => {
  if (conectado.value) emit('authenticated', true);
});

async function conectar() {
  error.value = '';
  cargando.value = true;
  try {
    await loginDjangoAdmin(email.value, password.value);
    conectado.value = true;
    emit('authenticated', true);
  } catch (e) {
    error.value = e.response?.data?.detail || e.message || 'No se pudo conectar.';
    conectado.value = false;
    emit('authenticated', false);
  } finally {
    cargando.value = false;
  }
}

function desconectar() {
  clearDjangoAdminSession();
  conectado.value = false;
  emit('authenticated', false);
}

function irAlHub() {
  router.push({ name: props.hubRoute });
}
</script>
